import type { CatalogCardMediaIndicator, CatalogCardMediaIndicatorText } from '../types';

export function isCatalogCardMediaIndicatorText(
  indicator: CatalogCardMediaIndicator,
): indicator is CatalogCardMediaIndicatorText {
  return (
    'label' in indicator && typeof (indicator as CatalogCardMediaIndicatorText).label === 'string'
  );
}
